export const ProductSectionSettingsEndpoint = {
  GET_ALL_SECTIONS: '/api/admin/product/section',
  CREATE_SECTION: '/api/admin/product/section',
  UPDATE_DISPLAY_NAME: (sectionName: string) => `/api/admin/product/section/${sectionName}`,
  TOGGLE_ENABLE: (sectionName: string) => `/api/admin/product/section/${sectionName}/toggleEnable`,
};
